export const isBlankGeo = (value) => {
  const text = String(value || "").trim()
  if (!text) return true
  if (/^(n\/a|na|unavailable|unknown|—|-)$/i.test(text)) return true
  return /^,\s*,?\s*$/.test(text)
}
